module.exports = __webpack_public_path__ + "static/media/CSPORT ACTIVE CROSSOVER ACN400.5e8df293.png";